<div class="blocks-container">
  <h1>{{ "blocks.gui.labels.Blocks Management" | translate }}</h1>
  
  <div class="loading-spinner" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!loading && blocks.length === 0" class="no-blocks">
    <p>{{ "blocks.gui.labels.No blocks to display" | translate }}</p>
  </div>

  <div *ngIf="!loading && blocks.length > 0" class="table-container">
    <table mat-table [dataSource]="blocks" class="blocks-table">
      
      <!-- Start Time Column -->
      <ng-container matColumnDef="startTime">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Start Date and Time" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ formatDate(block.startTime) }}</td>
      </ng-container>

      <!-- End Time Column -->
      <ng-container matColumnDef="endTime">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.End Date and Time" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ formatDate(block.endTime) }}</td>
      </ng-container>

      <!-- Duration Column -->
      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Duration (minutes)" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ block.duration }}</td>
      </ng-container>

      <!-- Resource Column -->
      <ng-container matColumnDef="resource">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Doctor/Room" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ getResourceName(block) }}</td>
      </ng-container>

      <!-- Creator Column -->
      <ng-container matColumnDef="creator">
        <th mat-header-cell *matHeaderCellDef>{{ "appointments.gui.labels.appointment_stats.Created By" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ getCreatorName(block) }}</td>
      </ng-container>

      <!-- Recurring Column -->
      <ng-container matColumnDef="isRecurring">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Recurring Block" | translate }}</th>
        <td mat-cell *matCellDef="let block">
          <div *ngIf="block.isRecurring">
            <mat-icon class="recurring-icon">repeat</mat-icon>
            <div class="recurring-details">
              <div *ngIf="block.daysOfWeek">{{ "blocks.gui.labels.Days" | translate }}: {{ getDaysOfWeekText(block.daysOfWeek) }}</div>
              <div *ngIf="block.repeatUntil">{{ "blocks.gui.labels.Until" | translate }}: {{ formatDate(block.repeatUntil) }}</div>
            </div>
          </div>
          <span *ngIf="!block.isRecurring">{{ "blocks.gui.labels.No" | translate }}</span>
        </td>
      </ng-container>

      <!-- Comment Column -->
      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Comment" | translate }}</th>
        <td mat-cell *matCellDef="let block">{{ block.comment || '-' }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ "blocks.gui.labels.Actions" | translate }}</th>
        <td mat-cell *matCellDef="let block">
          <button mat-icon-button color="warn" (click)="deleteBlock(block)" matTooltip="{{ 'blocks.gui.tooltips.Delete Block' | translate }}">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
